import React from 'react';
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import { DNABox, DNAText, Icon, Iffy, luxColors, Popover, util, } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
import PopOverVideoMenu from './VideoMenu';
import PopOverEndCall from './EndMeeting';
import { SettingsMenu } from './SettingsMenu';
const styles = StyleSheet.create({
    icon: {
        width: 24,
        height: 24,
        color: colors['color-text-basic'],
    },
    optionSelectedText: {
        color: luxColors.info.primary,
    },
    optionSelectedIcon: {
        color: luxColors.info.primary,
    },
    optionText: {
        color: colors['color-text-basic'],
        fontSize: 14,
        marginLeft: 6,
        marginTop: 3,
        textAlign: 'center',
    },
    sideBarOptionContainer: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        backgroundColor: 'rgba(255, 255, 255, 0.16)',
        borderRadius: 4,
        marginHorizontal: 6,
    },
    sideBarOptionContainerSelected: {
        backgroundColor: luxColors.thumbnailBorder.primary,
    },
});
export const SideBarMenuItem = (props) => {
    return (React.createElement(Popover, { type: "tooltip" },
        React.createElement(Popover.Anchor, null,
            React.createElement(DNABox, { style: [
                    util.mergeStyles(undefined, styles.sideBarOptionContainer, [styles.sideBarOptionContainerSelected, props.menuOption.active], [{ opacity: 0.4 }, props.menuOption.disabled], [{ backgroundColor: props.menuOption.backgroundColor }, props.menuOption.backgroundColor]),
                ], appearance: "col", alignY: "start", alignX: "center" },
                React.createElement(DNABox, { appearance: "row" },
                    React.createElement(DNABox, { appearance: "col" },
                        React.createElement(Icon, { name: props.menuOption.icon, style: [
                                util.mergeStyles(undefined, styles.icon, [styles.optionSelectedIcon, props.menuOption.active], [{ color: props.menuOption.color }, props.menuOption.color], [{ color: props.menuOption.selectedColor }, !!props.menuOption.selectedColor]),
                            ] }),
                        props.chip),
                    React.createElement(Iffy, { is: props.menuOption.showText },
                        React.createElement(Text, { style: util.mergeStyles(undefined, styles.optionText, [styles.optionSelectedText, props.menuOption.active]) }, props.menuOption.title))))),
        React.createElement(Popover.Content, null,
            React.createElement(DNAText, { status: "basic" }, props.menuOption.title))));
};
export function SideBarOption(props) {
    function onSelectedOption() {
        !props.menuOption.disabled && props.onSelectedOption(props.menuOption);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Iffy, { is: !props.menuOption.disabled },
            React.createElement(TouchableOpacity, { onPress: onSelectedOption },
                React.createElement(SideBarMenuItem, { menuOption: props.menuOption, active: props.menuOption.active, chip: props.chip }))),
        React.createElement(Iffy, { is: props.menuOption.disabled },
            React.createElement(DNABox, null,
                React.createElement(SideBarMenuItem, { menuOption: props.menuOption, active: props.menuOption.active, chip: props.chip })))));
}
// [TODO] - Menu is a bit rigid, consider writing it explicitly
function Menu(props) {
    const { isHeaderHidden, onSelectedOption, disabled, menuOptions } = props;
    const menuOptionsState = menuOptions.map(menuOption => (Object.assign(Object.assign({}, menuOption), { disabled: menuOption.disabled || disabled })));
    return (React.createElement(DNABox, { alignY: "center" }, menuOptionsState.map((menuOption) => (React.createElement(View, { key: menuOption.title },
        React.createElement(Iffy, { is: menuOption.id === 'settings' },
            React.createElement(SettingsMenu, { menuOption: menuOption, isHeaderHidden: isHeaderHidden, onSelectedOption: onSelectedOption })),
        React.createElement(Iffy, { is: menuOption.id === 'end_call' },
            React.createElement(PopOverEndCall, Object.assign({}, menuOption, { onSelectedOption: onSelectedOption }))),
        React.createElement(Iffy, { is: menuOption.id === 'view_compact' },
            React.createElement(PopOverVideoMenu, Object.assign({}, menuOption, { onSelectedOption: onSelectedOption }))),
        React.createElement(Iffy, { is: !['settings', 'end_call', 'view_compact'].includes(menuOption.id) },
            React.createElement(SideBarOption, { key: `sidebaroption_${menuOption.title}`, menuOption: menuOption, onSelectedOption: onSelectedOption, chip: menuOption.chip })))))));
}
export default Menu;
//# sourceMappingURL=Menu.js.map